import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { Message } from '@weezevent/nacre';

export function MissingEventMessage({ config = {} }) {
    const { t } = useTranslation();
    return !config.event_id ? (
        <div style={{ marginTop: 20 }}>
            <Message type="danger">{t('ticket.widget.queue_step.no_event_id')}</Message>
        </div>
    ) : null;
}

MissingEventMessage.propTypes = {
    config: PropTypes.object
};
